module.exports = __webpack_public_path__ + "img/03.9bd656d9.png";